import { getStoredRegistrationAttemptId } from "helpers/tracking";

const resource = "api/EventLogs";
const maxErrorMessageLength = 256;

export const productMetricsEventNames = {
    RegistrationOpened: "registration_opened",
    RegistrationInnEmailEntered: "registration_inn_email_entered",
    RegistrationPhonePasswordEntered: "registration_phone_password_entered",
    ContinueWithoutCars: "continue_without_cars",
    TryOnOneTransportation: "try_on_one_transportation",
    OnboardingStarted: "onboarding_started",
    OnboardingCompleted: "onboarding_completed",
} as const;

export type ProductMetricsEventName = (typeof productMetricsEventNames)[keyof typeof productMetricsEventNames];

export type ProductMetricHeaders = {
    metricClientId?: string;
    registrationAttemptId?: string;
};

type SendEventLogParams = ProductMetricHeaders & {
    name: ProductMetricsEventName;
    isSuccess?: boolean;
    errorMessage?: string;
    payload?: Record<string, unknown>;
};

const hasWindow = () => typeof window !== "undefined";

export const getProductMetricHeaders = ({ metricClientId, registrationAttemptId }: ProductMetricHeaders) => ({
    ...(metricClientId ? { "X-Metric-Client-Id": metricClientId } : {}),
    ...(registrationAttemptId ? { "X-Registration-Attempt-Id": registrationAttemptId } : {}),
});

const getRequestHeaders = ({ metricClientId, registrationAttemptId }: ProductMetricHeaders) => {
    const token = localStorage.getItem("token");
    const currentRegistrationAttemptId = registrationAttemptId ?? getStoredRegistrationAttemptId();

    return {
        "X-Device-Id": localStorage.getItem("deviceId") ?? "",
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "application/json; charset=utf-8",
        ...getProductMetricHeaders({ metricClientId, registrationAttemptId: currentRegistrationAttemptId }),
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
};

const getErrorMessage = (errorMessage?: string) => {
    if (!errorMessage) {
        return undefined;
    }

    return errorMessage.slice(0, maxErrorMessageLength);
};

export const sendEventLog = ({
    name,
    isSuccess = true,
    errorMessage,
    payload = {},
    metricClientId,
    registrationAttemptId,
}: SendEventLogParams) => {
    if (!hasWindow()) {
        return Promise.resolve(false);
    }

    return fetch(`/${resource}/Send`, {
        method: "POST",
        cache: "default",
        headers: getRequestHeaders({ metricClientId, registrationAttemptId }),
        body: JSON.stringify({
            name,
            isSuccess,
            errorMessage: getErrorMessage(errorMessage),
            payload,
        }),
    })
        .then((res) => {
            if (!res.ok) {
                console.warn({ type: "warning", message: "Не удалось отправить продуктовую метрику", name, res });
                return false;
            }

            return true;
        })
        .catch((err) => {
            console.error({ type: "error", message: "Не удалось отправить продуктовую метрику", name, err });
            return false;
        });
};
